"use client";

import React from "react";
import { Github, Mail } from "lucide-react";

const Terms = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 flex flex-col items-center p-4 sm:p-8 font-sans">
      {/* Terms of Service Content Section */}
      <main className="w-full max-w-7xl py-12 md:py-20 px-4 text-left">
        <h1 className="text-4xl sm:text-5xl font-extrabold text-slate-900 leading-tight mb-4">
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-teal-500 to-orange-500">
            Terms of Service
          </span>
        </h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: October 26, 2023</p>

        <div className="space-y-8 text-gray-700">
          <section>
            <h2 className="text-2xl font-bold mb-2">1. Acceptance of Terms</h2>
            <p className="text-lg">
              By accessing and using our application, you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-2">2. User Accounts</h2>
            <p className="text-lg">
              When you create an account, you are responsible for maintaining the security of your account, and you are fully responsible for all activities that occur under the account and any other actions taken in connection with it.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-2">3. Intellectual Property</h2>
            <p className="text-lg">
              The application and all of its original content, features, and functionality are owned by us and are protected by international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-2">4. User Content</h2>
            <p className="text-lg">
              You retain all ownership rights to the content you create and submit to the service. However, by submitting content, you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, and display the content solely for the purpose of operating and improving the application.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-bold mb-2">5. Prohibited Uses</h2>
            <p className="text-lg">
              You may not use the application for any unlawful purposes or to solicit the performance of any illegal activity or other activity which infringes the rights of our company or others.
            </p>
          </section>
        </div>
      </main>

      {/* Footer Section */}
      <footer className="w-full max-w-7xl flex flex-col items-center py-8 px-4 border-t border-gray-200 mt-12">
        <div className="flex space-x-6 text-gray-500 mb-4">
          <a href="#" className="hover:text-teal-600 transition" aria-label="GitHub">
            <Github size={24} />
          </a>
          <a href="#" className="hover:text-teal-600 transition" aria-label="Email">
            <Mail size={24} />
          </a>
        </div>
        <p className="text-gray-500 text-sm">
          &copy; {new Date().getFullYear()} LoR App. All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default Terms;